import { render, staticRenderFns } from "./ReservationPanel.vue?vue&type=template&id=79f55ea0&"
import script from "./ReservationPanel.vue?vue&type=script&lang=js&"
export * from "./ReservationPanel.vue?vue&type=script&lang=js&"
import style0 from "./ReservationPanel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports